export const TRIAL_PICKER_BUTTON_ID = 'hs-global-toolbar-free-trials-list-item';